import Chelia61 from './Chelia 6 2 Lantai (1).webp'
import Chelia62 from './Chelia 6 2 Lantai (2).webp'



const Chelia6images =[
Chelia61,Chelia62
]

export default Chelia6images;